<template>
  <div class="warehouseSettingsDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="warehouseSettingsDetail-radio">
        <div class="radio-label">{{ $t.warehouse.formName }}</div>
        <van-radio-group v-model="form.FormName" direction="horizontal">
          <van-radio name="1">{{ $t.warehouse.nameOption1 }}</van-radio>
          <van-radio name="2">{{ $t.warehouse.nameOption2 }}</van-radio>
        </van-radio-group>
      </div>

      <van-field :label="$t.warehouse.formState" readonly>
        <template #right-icon>
          <van-switch
            v-model="form.FormState"
            active-value="1"
            inactive-value="0"
            size="24"
          />
        </template>
      </van-field>

      <van-field v-model="formItem" :label="$t.warehouse.object" readonly v-if="isEdit" />

      <van-field
        v-model="form.DisplayContent"
        :label="$t.warehouse.displayContent"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
        type="textarea"
        rows="5"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Switch, Radio, RadioGroup } from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Switch)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "warehouseSettingsDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isEdit: false,
      wfsid: "",
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      formItem: "",
    };
  },
  created() {
    const { WFSId, IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      if (WFSId) {
        this.wfsid = WFSId;
        this.getWarehouseFormSettingDetail();
      }
    } else {
      this.form = {
        WFSId: "",
        FormState: "0",
        FormName: "",
        FormItem: "",
        DisplayContent: "",
      };
    }
  },
  methods: {
    getWarehouseFormSettingDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WFSId: this.wfsid,
        };
        this.$api.storage
          .getWarehouseFormSettingDetail(param)
          .then((res) => {
            this.form = res.data;
            if (this.form.FormItem == "1") {
              this.formItem = this.$t.warehouse.nameOption1;
            }
            if (this.form.FormItem == "2") {
              this.formItem = this.$t.warehouse.nameOption2;
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.isEdit) {
        request = this.$api.storage.editWarehouseFormSetting(param);
      } else {
        request = this.$api.storage.addWarehouseFormSetting(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.warehouseSettingsDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .warehouseSettingsDetail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
}
</style>
